/**
 * TNA Demo API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@meddv.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Call } from '../models/call';
import { Calls } from '../models/calls';
import { NoContent } from '../models/noContent';

import { ConfigRESTServable, Configuration, CustomHttpUrlEncodingCodec } from '@nida-web/api/generic-interfaces/config';

@Injectable({
  providedIn: 'root',
})
export class CallService {
  protected apiPrefix = '';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, private configSubject: ConfigRESTServable) {
    this.configSubject.getRESTURL().subscribe((apiUrl) => {
      this.apiPrefix = apiUrl + 'tna-demo';
    });
  }

  /**
   *
   * Create call
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createCall(body: Call, observe?: 'body', reportProgress?: boolean): Observable<Call>;
  public createCall(body: Call, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Call>>;
  public createCall(body: Call, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Call>>;
  public createCall(body: Call, observe: any = 'body', reportProgress = false): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling createCall.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Call>('post', `${this.apiPrefix}/call`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   * Delete Call
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteCall(id: number, observe?: 'body', reportProgress?: boolean): Observable<NoContent>;
  public deleteCall(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NoContent>>;
  public deleteCall(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NoContent>>;
  public deleteCall(id: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deleteCall.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<NoContent>('delete', `${this.apiPrefix}/call/${encodeURIComponent(String(id))}`, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   * Get call
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCall(id: number, observe?: 'body', reportProgress?: boolean): Observable<Call>;
  public getCall(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Call>>;
  public getCall(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Call>>;
  public getCall(id: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getCall.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<Call>('get', `${this.apiPrefix}/call/${encodeURIComponent(String(id))}`, {
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   * Get calls
   * @param ressourceName
   * @param deviceSerial
   * @param callId
   * @param deviceState
   * @param callState
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getCalls(
    ressourceName?: string,
    deviceSerial?: string,
    callId?: string,
    deviceState?: string,
    callState?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Calls>;
  public getCalls(
    ressourceName?: string,
    deviceSerial?: string,
    callId?: string,
    deviceState?: string,
    callState?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Calls>>;
  public getCalls(
    ressourceName?: string,
    deviceSerial?: string,
    callId?: string,
    deviceState?: string,
    callState?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Calls>>;
  public getCalls(
    ressourceName?: string,
    deviceSerial?: string,
    callId?: string,
    deviceState?: string,
    callState?: string,
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    if (ressourceName !== undefined && ressourceName !== null) {
      queryParameters = queryParameters.set('ressourceName', <any>ressourceName);
    }
    if (deviceSerial !== undefined && deviceSerial !== null) {
      queryParameters = queryParameters.set('deviceSerial', <any>deviceSerial);
    }
    if (callId !== undefined && callId !== null) {
      queryParameters = queryParameters.set('callId', <any>callId);
    }
    if (deviceState !== undefined && deviceState !== null) {
      queryParameters = queryParameters.set('deviceState', <any>deviceState);
    }
    if (callState !== undefined && callState !== null) {
      queryParameters = queryParameters.set('callState', <any>callState);
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.request<Calls>('get', `${this.apiPrefix}/calls`, {
      params: queryParameters,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   *
   * Update call
   * @param body
   * @param id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateCall(body: Call, id: number, observe?: 'body', reportProgress?: boolean): Observable<Call>;
  public updateCall(body: Call, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Call>>;
  public updateCall(body: Call, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Call>>;
  public updateCall(body: Call, id: number, observe: any = 'body', reportProgress = false): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling updateCall.');
    }

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateCall.');
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function' ? this.configuration.accessToken() : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json', 'text/plain'];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<Call>('put', `${this.apiPrefix}/call/${encodeURIComponent(String(id))}`, {
      body: body,
      withCredentials: this.configuration.withCredentials,
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
